import { render, staticRenderFns } from "./ColaC.vue?vue&type=template&id=361740e1&scoped=true"
import script from "./ColaC.vue?vue&type=script&lang=js"
export * from "./ColaC.vue?vue&type=script&lang=js"
import style0 from "./ColaC.vue?vue&type=style&index=0&id=361740e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361740e1",
  null
  
)

export default component.exports